import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocalizedState } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import { Editable } from '../common/Editable';
import { Title } from '../common/Text';
import { Button } from '../common/button/Button';
import { ArchiveIcon } from '../icons';

export function LibraryTitle(props: {
	title: graphql.LocalizedString;
	onChange: (title: graphql.LocalizedString) => Promise<void>;
	onArchive: () => Promise<void>;
	onRestore: () => Promise<void>;
	isArchived: boolean;
}) {
	const { t } = useTranslation();

	const [title, setTitle] = useState(props.title);
	const [localizedTitle, setLocalizedTitle] = useLocalizedState(title, setTitle);

	return (
		<Editable.Flex
			flexible
			value={localizedTitle}
			onChange={async (title) => {
				await props.onChange(await setLocalizedTitle(title));
			}}
			buttons={
				props.isArchived ? (
					<Button
						small
						ml={2}
						type="destructive"
						title={t('common.restore')}
						onClick={async () => {
							await props.onRestore();
						}}
					/>
				) : (
					<Button
						small
						ml={2}
						type="destructive"
						icon={<ArchiveIcon />}
						title={t('common.archive')}
						onClick={async () => {
							await props.onArchive();
						}}
					/>
				)
			}
		>
			{(value) => <Title>{value}</Title>}
		</Editable.Flex>
	);
}
